import { RecurrentScheduleDao, ScheduleDao } from '@raysee/dao';
import { RecurrentSchedule } from '@raysee/schema';
import dayjs from 'dayjs';
import { useAsyncCallback } from 'react-async-hook';

export const useDeleteRecurrentSchedule = () =>
  useAsyncCallback(async (recurrentSchedule: RecurrentSchedule) => {
    await RecurrentScheduleDao().delete(recurrentSchedule.id);
    const schedules = await ScheduleDao()
      .where('recurrentScheduleId', '==', recurrentSchedule.id)
      .fetch();
    await Promise.all(
      schedules
        .filter((schedule) => dayjs().isBefore(schedule.startTime))
        .map((schedule) => ScheduleDao().delete(schedule.id)),
    );
  });
